module.exports = __webpack_public_path__ + "media/recipes/160-5bb1ed52.png";